import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const TESTIMONIALS = [{
  quote: 'Antes de conocer la Ruta Clínica, invertía demasiado tiempo buscando información antes de atender pacientes con obesidad. Hoy solo sigo los algoritmos y tengo mucha más seguridad para decidir.',
  name: 'Dra. María P.',
  role: 'Medicina Familiar • Colombia 🇨🇴',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/73d861a0-2bc4-467e-9a67-dfd145e979c0.jpg'
}, {
  quote: 'El segundo tomo cambió por completo mi forma de seleccionar tratamientos. Ahora sé exactamente cuándo iniciar un GLP-1, cómo titularlo y cómo hacer el seguimiento.',
  name: 'Dr. Roberto G.',
  role: 'Medicina Interna • México 🇲🇽',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/84d8fa1c-8b6c-494d-9c61-1580c91e491a.jpg'
}, {
  quote: 'Los checklists y los casos clínicos son las herramientas que más utilizo. Me ayudan a no olvidar ningún detalle durante la consulta.',
  name: 'Dra. Andrea L.',
  role: 'Endocrinología • Argentina 🇦🇷',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/5d1b7d9e-ef83-4d74-9908-d8e35437e77f.jpg'
}, {
  quote: 'Los scripts para mejorar la adherencia marcaron una gran diferencia. Mis pacientes entienden mucho mejor el tratamiento y abandonan menos.',
  name: 'Dr. José V.',
  role: 'Medicina General • España 🇪🇸',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/8b7c0b1c-e5f2-4c95-bca3-1e8396b0fbd8.jpg'
}];
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-206" data-mp="q5lbn4x2yqys">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-207" data-mp="v4o6xxn9ditk" />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white px-4 py-14" data-id="element-208" data-mp="1nm0iewm4ovvm">
      <div className="mx-auto max-w-3xl" data-id="element-209" data-mp="1nnlc6k0mcasf">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-210" data-mp="1xi0mj81kxrxl">
          Lo que ya están diciendo otros médicos
        </h2>
        <div className="mt-3 flex flex-col items-center gap-1.5" data-id="element-211" data-mp="1sjpgz9ibi3l6">
          <Stars data-id="element-212" data-mp="1og9lighzi9a2" />
          <p className="text-[13px] font-semibold text-navy/60" data-id="element-213" data-mp="1ofreqpxp4cnw">
            Más de 2.000 profesionales ya utilizan esta metodología.
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-214" data-mp="1ejem7vdw04uq">
          {TESTIMONIALS.map(t => <figure key={t.name} className="flex flex-col rounded-2xl border border-navy-100 bg-cream p-5 shadow-sm" data-id="element-215" data-mp="19rwnzf390idg">
              <Stars data-id="element-216" data-mp="14r8sag42rdcw" />
              <blockquote className="mt-3 flex-1 text-[14px] leading-relaxed text-navy/80" data-id="element-217" data-mp="10s01nk4bzvlk">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-navy-100 pt-4" data-id="element-218" data-mp="vs3xnkvmw460">
                <img src={t.image} alt={`Foto de ${t.name}`} className="h-12 w-12 rounded-full object-cover" loading="lazy" data-id="element-219" data-mp="qu2g54duwcwn" />
                <div data-id="element-220" data-mp="37e5upy9geu1u">
                  <div className="text-[14px] font-bold text-navy-900" data-id="element-221" data-mp="3cf3lgz8j4wey">{t.name}</div>
                  <div className="text-[12px] text-navy/55" data-id="element-222" data-mp="3ccz53htg24xs">{t.role}</div>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-9 flex justify-center" data-id="element-223" data-mp="2jrpioki5h6mx">
          <CTAButton label="UNIRME A LOS +2.000 MÉDICOS" sublabel="Acceso inmediato · Pago único de $12.99 USD" pulse={false} data-id="element-224" data-mp="2opiqtj30kapu" />
        </div>
      </div>
    </section>;
}